import fakedb from "../fakedb.json";
/**
 * Created by Federico Brocco on 13/05/2022.
 *
 * @format
 */

/**
 * Recupera l'elenco dei tipi di regolamentazione disponibili
 * @returns {Promise<Array>} Promise che risolve con un array di tipi di regolamentazione
 */
let list = function () {
    return new Promise(function (resolve, reject) {

        fetch(window.route.regolationsType, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API regulations list', responseJson);
                resolve(responseJson.regulation_types);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Recupera i dettagli delle regolamentazioni per un tipo specifico
 * @param {string|number} regulation_type_id - L'ID del tipo di regolamentazione
 * @returns {Promise<Array>} Promise che risolve con un array di regolamentazioni per il tipo specificato
 */
let detail = function (regulation_type_id) {
    return new Promise(function (resolve, reject) {

        fetch(window.route.regolationsDetail + "?regulation_type_id=" + regulation_type_id, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API regulations detail', responseJson);
                resolve(responseJson.regulations);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};



const RegulationsAPI = {
    list: list,
    detail: detail
};

export default RegulationsAPI;
